module.exports = __webpack_public_path__ + "media/images/flags/BD-709565ef3c9e14584f931c79b96fbb24.svg";